import { render, staticRenderFns } from "./UpdateMeLog.vue?vue&type=template&id=0d977c36&lang=pug&"
import script from "./UpdateMeLog.vue?vue&type=script&lang=ts&"
export * from "./UpdateMeLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports